import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import logoLight from "../../assets/images/amblem_light.png";
import logoDark from "../../assets/images/amblemlight2.png";
import { useTheme } from "../../contexts/ThemeContext";
import { useLanguage } from "../../contexts/LanguageContext";
import ios from "../../assets/mobil/ios.png";
import google from "../../assets/mobil/google.png";

const Footer: React.FC = () => {
  const { theme } = useTheme();
  const { t } = useLanguage();
  
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-left">
          <img
            src={theme === "light" ? logoLight : logoDark}
            alt="Has Gümüş Logo"
            className="footer-logo"
          />

          <div className="footer-store-links" aria-label="Download links">
            <a
              href="https://apps.apple.com/tr/app/has-g%C3%BCm%C3%BC%C5%9F/id1545326507?l=tr"
              target="_blank"
              rel="noopener noreferrer"
              className="store-link"
            >
              <img src={ios} alt="App Store" className="store-icon" />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.aifasoft.has_gumus&hl=tr"
              target="_blank"
              rel="noopener noreferrer"
              className="store-link"
            >
              <img src={google} alt="Google Play" className="store-icon" />
            </a>
          </div>
        </div>

        <div className="footer-right">
          <div className="footer-col footer-col--links">
            <div className="footer-heading">{t("features.hizliBaglantilar")}</div>
            <nav className="footer-menu" aria-label="Footer navigation">
              <Link to="/" className="footer-menu-item">
                {t("footer.anaSayfa")}
              </Link>
              <Link to="/about" className="footer-menu-item">
                {t("footer.hakkimizda")}
              </Link>
              <Link to="/products" className="footer-menu-item">
                {t("footer.bilgiToplumHizmetleri")}
              </Link>
              <Link to="/contact" className="footer-menu-item">
                {t("footer.iletisim")}
              </Link>
            </nav>
          </div>

          <div className="footer-col footer-col--meta">
            <p className="footer-text">{t("footer.copyright")}</p>
            <p className="footer-info">{t("footer.kurlarBilgi")}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;